export default "__VITE_ASSET__Bhjo_iP7__"